<template>
    <div class="col-sm-6 col-md-3 col-lg-3 d-flex align-items-end">
        <div class="form-group w-100">
            <select class="form-control" name="include_variants" @change="changeVariant($event)">
                <option
                    :key="value"
                    v-for="(value, label) in extraFilters.variants"
                    v-text="label"
                    :value="value"
                    :selected="value == extraFilters.current.include_variants"
                ></option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: ['extraFilters', 'translations'],

    data() {
        return {};
    },

    methods: {
        changeVariant({ target }) {
            this.$emit('onFilter', {
                data: { value: target.value }
            });
        }
    }
};
</script>
